import { render, staticRenderFns } from "./award.vue?vue&type=template&id=452e7fa0&scoped=true&"
import script from "./award.vue?vue&type=script&lang=js&"
export * from "./award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e7fa0",
  null
  
)

export default component.exports